/**
 * Modal Stack Item Interface
 * Represents a modal in the stack with its metadata
 */
export interface ModalStackItem {
  id: string;
  type: string;
  routeId: string; // product-123, order-456
  timestamp: number;
  zIndex: number;
}

/**
 * Individual Modal Instance State
 * Tracks loading and error state for each modal
 */
export interface ModalInstanceState {
  loading: boolean;
  error: Error | null;
}

/**
 * Main Modal State Interface
 * Centralized state for all modal management
 */
export interface ModalState {
  // Stack of currently active modals
  stack: ModalStackItem[];

  // Individual states for each modal (loading, error)
  modalStates: Record<string, ModalInstanceState>;

  // Next z-index value for new modals
  nextZIndex: number;
}

/**
 * Constants for modal management
 */
export const MODAL_CONSTANTS = {
  BASE_Z_INDEX: 1000,
  Z_INDEX_GAP: 100,
  MAX_STACK_SIZE: 5,
} as const;
